interface Luna {
  [key: string]: string;
}
interface Luna {
  //CAN
  canh: string;
  tan: string;
  nham: string;
  quy: string;
  giap: string;
  at: string;
  binh: string;
  dinh: string;
  mau: string;
  ky: string;
  //CHI
  than: string;
  dau: string;
  tuat: string;
  hoi: string;
  tys: string;
  suu: string;
  dan: string;
  mao: string;
  thin: string;
  tyj: string;
  ngo: string;
  mui: string;
  //CAN CHI
  giap_tys: string;
  giap_dan: string;
  giap_thin: string;
  giap_ngo: string;
  giap_than: string;
  giap_tuat: string;
  at_suu: string;
  at_mao: string;
  at_tyj: string;
  at_mui: string;
  at_dau: string;
  at_hoi: string;
  binh_tys: string;
  binh_dan: string;
  binh_thin: string;
  binh_ngo: string;
  binh_than: string;
  binh_tuat: string;
  dinh_suu: string;
  dinh_mao: string;
  dinh_tyj: string;
  dinh_mui: string;
  dinh_dau: string;
  dinh_hoi: string;
  mau_tys: string;
  mau_dan: string;
  mau_thin: string;
  mau_ngo: string;
  mau_than: string;
  mau_tuat: string;
  ky_suu: string;
  ky_mao: string;
  ky_tyj: string;
  ky_mui: string;
  ky_dau: string;
  ky_hoi: string;
  canh_tys: string;
  canh_dan: string;
  canh_thin: string;
  canh_ngo: string;
  canh_than: string;
  canh_tuat: string;
  tan_suu: string;
  tan_mao: string;
  tan_tyj: string;
  tan_mui: string;
  tan_dau: string;
  tan_hoi: string;
  nham_tys: string;
  nham_dan: string;
  nham_thin: string;
  nham_ngo: string;
  nham_than: string;
  nham_tuat: string;
  quy_suu: string;
  quy_mao: string;
  quy_tyj: string;
  quy_mui: string;
  quy_dau: string;
  quy_hoi: string;
  //NGU HANH
  kim: string;
  moc: string;
  tho: string;
  thuy: string;
  hoa: string;
  //BAT QUAI
  cans: string;
  ton: string;
  khon: string;
  canf: string;
  doai: string;
  ly: string;
  chan: string;
  kham: string;
  //NGAY TRONG TUAN
  chu_nhat: string;
  thu_hai: string;
  thu_ba: string;
  thu_tu: string;
  thu_nam: string;
  thu_sau: string;
  thu_bay: string;
  //24 TIET KHI
  xuan_phan: string; //0:
  thanh_minh: string; //15:
  coc_vu: string; //30:
  lap_ha: string; //45:
  tieu_man: string; //60:
  mang_chung: string; //75:
  ha_chi: string; //90:
  tieu_thu: string; //105:
  dai_thu: string; //120:
  lap_thu: string; //135:
  xu_thu: string; //150:
  bach_lo: string; //165:
  thu_phan: string; //180:
  han_lo: string; //195:
  suong_giang: string; //210:
  lap_dong: string; //225:
  tieu_tuyet: string; //240:
  dai_tuyet: string; //255:
  dong_chi: string; //270:
  tieu_han: string; //285:
  dai_han: string; //300:
  lap_xuan: string; //315:
  vu_thuy: string; //330:
  kinh_trap: string; //345:
  // 12 TRUC
  truc_kien: string;
  truc_tru: string;
  truc_man: string;
  truc_binh: string;
  truc_dinh: string;
  truc_chap: string;
  truc_pha: string;
  truc_nguy: string;
  truc_thanh: string;
  truc_thu: string;
  truc_khai: string;
  truc_be: string;
  //28 TINH TUC
  tinh_hu: string;
  tinh_nguy: string;
  tinh_that: string;
  tinh_bich: string;
  tinh_khue: string;
  tinh_lau: string;
  tinh_vij: string;
  tinh_mao: string;
  tinh_tat: string;
  tinh_chuy: string;
  tinh_sam: string;
  tinh_tinhr: string;
  tinh_quy: string;
  tinh_lieu: string;
  tinh_tinh: string;
  tinh_truong: string;
  tinh_duc: string;
  tinh_chan: string;
  tinh_giac: string;
  tinh_cang: string;
  tinh_de: string;
  tinh_phong: string;
  tinh_tam: string;
  tinh_vix: string;
  tinh_co: string;
  tinh_dau: string;
  tinh_nguu: string;
  tinh_nu: string;
  nguyet_ky: string;
  tam_nuong: string;
  tho_tu: string;
  sat_chu_am: string;
  sat_chu_duong: string;
  vang_vong: string;
  nguyet_pha: string;
  tue_pha: string;
  dai_hao: string;
  khong_pham: string;
}

export type CalendarDetail = {
  dateSolar: string;
  dateLunar: string;
  daySolar: number;
  monthSolar: number;
  yearSolar: number;
  dayLunar: number;
  monthLunar: number;
  yearLunar: number;
  ngayCan: string;
  ngayChi: string;
  thangCan: string;
  thangChi: string;
  namCan: string;
  namChi: string;
  truc: string;
  tu: string;
  hanhNgay: string;
  hanhThang: string;
  isLeap: boolean;
  weekday: string;
  gioHoangDao: {
    order: number;
    name: string;
    start: number;
    end: number;
    nguHanh: string;
  }[];
  gioThoTu: {
    order: number;
    name: string;
    start: number;
    end: number;
    nguHanh: string;
  };
  gioSatChu: {
    order: number;
    name: string;
    start: number;
    end: number;
    nguHanh: string;
  };
  tuoiXungNgay: {
    order: number;
    key: string;
    nguHanh: string;
  }[];
  tuoiXungThang: {
    order: number;
    key: string;
    nguHanh: string;
  }[];
  tiet: string;
  bachKy: string[];
  isHaveEvents: boolean;
  events: any[];
  isHoangDaoDay: boolean;
  hoangDaoHacDao: {
    isDayHoangDaoHacDao: boolean;
    isHoangDaoDay: boolean;
  };
};
export type CalendarList = CalendarDetail[];
const formatLuna: Luna = {
  //CAN
  canh: "Canh",
  tan: "Tân",
  nham: "Nhâm",
  quy: "Quý",
  giap: "Giáp",
  at: "Ất",
  binh: "Bính",
  dinh: "Đinh",
  mau: "Mậu",
  ky: "Kỷ",
  //CHI
  than: "Thân",
  dau: "Dậu",
  tuat: "Tuất",
  hoi: "Hợi",
  tys: "Tý",
  suu: "Sửu",
  dan: "Dần",
  mao: "Mão",
  thin: "Thìn",
  tyj: "Tỵ",
  ngo: "Ngọ",
  mui: "Mùi",
  //CAN CHI
  giap_tys: "Giáp Tý",
  giap_dan: "Giáp Dần",
  giap_thin: "Giáp Thìn",
  giap_ngo: "Giáp Ngọ",
  giap_than: "Giáp Thân",
  giap_tuat: "Giáp Tuất",
  at_suu: "Ất Sửu",
  at_mao: "Ất Mão",
  at_tyj: "Ất Tỵ",
  at_mui: "Ất Mùi",
  at_dau: "Ất Dậu",
  at_hoi: "Ất Hợi",
  binh_tys: "Bính Tý",
  binh_dan: "Bính Dần",
  binh_thin: "Bính Thìn",
  binh_ngo: "Bính Ngọ",
  binh_than: "Bính Thân",
  binh_tuat: "Bính Tuất",
  dinh_suu: "Đinh Sửu",
  dinh_mao: "Đinh Mão",
  dinh_tyj: "Đinh Tỵ",
  dinh_mui: "Đinh Mùi",
  dinh_dau: "Đinh Dậu",
  dinh_hoi: "Đinh Hợi",
  mau_tys: "Mậu Tý",
  mau_dan: "Mậu Dần",
  mau_thin: "Mậu Thìn",
  mau_ngo: "Mậu Ngọ",
  mau_than: "Mậu Thân",
  mau_tuat: "Mậu Tuất",
  ky_suu: "Kỷ Sửu",
  ky_mao: "Kỷ Mão",
  ky_tyj: "Kỷ Tỵ",
  ky_mui: "Kỷ Mùi",
  ky_dau: "Kỷ Dậu",
  ky_hoi: "Kỷ Hợi",
  canh_tys: "Canh Tý",
  canh_dan: "Canh Dần",
  canh_thin: "Canh Thìn",
  canh_ngo: "Canh Ngọ",
  canh_than: "Canh Thân",
  canh_tuat: "Canh Tuất",
  tan_suu: "Tân Sửu",
  tan_mao: "Tân Mão",
  tan_tyj: "Tân Tỵ",
  tan_mui: "Tân Mùi",
  tan_dau: "Tân Dậu",
  tan_hoi: "Tân Hợi",
  nham_tys: "Nhâm Tý",
  nham_dan: "Nhâm Dần",
  nham_thin: "Nhâm Thìn",
  nham_ngo: "Nhâm Ngọ",
  nham_than: "Nhâm Thân",
  nham_tuat: "Nhâm Tuất",
  quy_suu: "Quý Sửu",
  quy_mao: "Quý Mão",
  quy_tyj: "Quý Tỵ",
  quy_mui: "Quý Mùi",
  quy_dau: "Quý Dậu",
  quy_hoi: "Quý Hợi",
  //NGU HANH
  kim: "Kim",
  moc: "Mộc",
  tho: "Thổ",
  thuy: "Thuỷ",
  hoa: "Hoả",
  //BAT QUAI
  cans: "Cấn",
  ton: "Tốn",
  khon: "Khôn",
  canf: "Càn",
  doai: "Đoài",
  ly: "Ly",
  chan: "Chấn",
  kham: "Khảm",
  //NGAY TRONG TUAN
  chu_nhat: "Chủ Nhật",
  thu_hai: "Thứ Hai",
  thu_ba: "Thứ Ba",
  thu_tu: "Thứ Tư",
  thu_nam: "Thứ Năm",
  thu_sau: "Thứ Sáu",
  thu_bay: "Thứ Bảy",
  //24 TIET KHI
  xuan_phan: "Xuân phân", //0:
  thanh_minh: "Thanh minh", //15:
  coc_vu: "Cốc vũ", //30:
  lap_ha: "Lập hạ", //45:
  tieu_man: "Tiểu mãn", //60:
  mang_chung: "Mang chủng", //75:
  ha_chi: "Hạ chí", //90:
  tieu_thu: "Tiểu thử", //105:
  dai_thu: "Đại thử", //120:
  lap_thu: "Lập thu", //135:
  xu_thu: "Xử thử", //150:
  bach_lo: "Bạch lộ", //165:
  thu_phan: "Thu phân", //180:
  han_lo: "Hàn lộ", //195:
  suong_giang: "Sương giáng", //210:
  lap_dong: "Lập đông", //225:
  tieu_tuyet: "Tiểu tuyết", //240:
  dai_tuyet: "Đại tuyết", //255:
  dong_chi: "Đông chí", //270:
  tieu_han: "Tiểu hàn", //285:
  dai_han: "Đại hàn", //300:
  lap_xuan: "Lập xuân", //315:
  vu_thuy: "Vũ thủy", //330:
  kinh_trap: "Kinh trập", //345:
  // 12 TRUC
  truc_kien: "Kiến",
  truc_tru: "Trừ",
  truc_man: "Mãn",
  truc_binh: "Bình",
  truc_dinh: "Định",
  truc_chap: "Chấp",
  truc_pha: "Phá",
  truc_nguy: "Nguy",
  truc_thanh: "Thành",
  truc_thu: "Thu",
  truc_khai: "Khai",
  truc_be: "Bế",
  //28 TINH TUC
  tinh_hu: "Hư",
  tinh_nguy: "Nguy",
  tinh_that: "Thất",
  tinh_bich: "Bích",
  tinh_khue: "Khuê",
  tinh_lau: "Lâu",
  tinh_vij: "Vị",
  tinh_mao: "Mão",
  tinh_tat: "Tất",
  tinh_chuy: "Chủy",
  tinh_sam: "Sâm",
  tinh_tinhr: "Tỉnh",
  tinh_quy: "Quỷ",
  tinh_lieu: "Liễu",
  tinh_tinh: "Tinh",
  tinh_truong: "Trương",
  tinh_duc: "Dực",
  tinh_chan: "Chẩn",
  tinh_giac: "Giác",
  tinh_cang: "Cang",
  tinh_de: "Đê",
  tinh_phong: "Phòng",
  tinh_tam: "Tâm",
  tinh_vix: "Vĩ",
  tinh_co: "Cơ",
  tinh_dau: "Đẩu",
  tinh_nguu: "Ngưu",
  tinh_nu: "Nữ",
  //BACHKY
  nguyet_ky: "Nguyệt kỵ",
  tam_nuong: "Tam Nương",
  tho_tu: "Thọ Tử",
  sat_chu_am: "Sát chủ âm",
  sat_chu_duong: "Sát chủ dương",
  vang_vong: "Vãng vong",
  nguyet_pha: "Nguyệt Phá",
  tue_pha: "Tuế Phá",
  dai_hao: "Đại Hao",
  khong_pham: "Không phạm",
};

export default formatLuna;
